import { styled, xStyledCommonProps } from '@elliemae/ds-system';
import type { XstyledProps } from '@elliemae/ds-props-helpers';
import { DSComboBoxName, DSComboboxSlots } from '../../theming.js';

import type {} from '@xstyled/system';

export const StyledContainer = styled('div', {
  name: DSComboBoxName,
  slot: DSComboboxSlots.CONTAINER,
})<XstyledProps & { disabled?: boolean; applyAriaDisabled: boolean }>`
  position: relative;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'default')};
  cursor: ${({ applyAriaDisabled }) => (applyAriaDisabled ? 'not-allowed' : 'default')};
  min-width: 64px;
  ${xStyledCommonProps}
`;

export const StyledPopperWrapper = styled('div')<{ disabled?: boolean; applyAriaDisabled: boolean }>`
  position: relative;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'default')};
  cursor: ${({ applyAriaDisabled }) => (applyAriaDisabled ? 'not-allowed' : 'default')};
  overflow: auto;
`;
